var InviteCodeStatus = /* @__PURE__ */ ((InviteCodeStatus2) => {
  InviteCodeStatus2[InviteCodeStatus2["UNUSED"] = 0] = "UNUSED";
  InviteCodeStatus2[InviteCodeStatus2["USED"] = 1] = "USED";
  InviteCodeStatus2[InviteCodeStatus2["DISABLED"] = 2] = "DISABLED";
  return InviteCodeStatus2;
})(InviteCodeStatus || {});
const INVITE_CODE_STATUS_TEXT = {
  [0 /* UNUSED */]: "\u672A\u4F7F\u7528",
  [1 /* USED */]: "\u5DF2\u4F7F\u7528",
  [2 /* DISABLED */]: "\u5DF2\u505C\u7528"
};
const INVITE_EXPIRE_HOUR_OPTIONS = [
  { hours: 1, label: "1 \u5C0F\u65F6" },
  { hours: 2, label: "2 \u5C0F\u65F6" },
  { hours: 24, label: "24 \u5C0F\u65F6" },
  { hours: 48, label: "48 \u5C0F\u65F6" }
];
const INVITE_EXPIRE_NEVER = 0;
const INVITE_EXPIRE_ALLOWED_HOURS = [
  ...INVITE_EXPIRE_HOUR_OPTIONS.map((o) => o.hours),
  INVITE_EXPIRE_NEVER
];
const INVITE_EXPIRE_DEFAULT_HOURS = INVITE_EXPIRE_HOUR_OPTIONS[0].hours;
export {
  INVITE_CODE_STATUS_TEXT,
  INVITE_EXPIRE_ALLOWED_HOURS,
  INVITE_EXPIRE_DEFAULT_HOURS,
  INVITE_EXPIRE_HOUR_OPTIONS,
  INVITE_EXPIRE_NEVER,
  InviteCodeStatus
};
